import { httpRequest } from "../../http";


export class CommandGetCatalogSettings{
    async run(organizationId: number) {
            const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${organizationId}/store/pages/config/?name=Home`
            try {
                const response = await httpRequest<any>(url, { method: "GET" });
                if(response) {
                    return response;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
    }

    
}
